import { UFS_BR } from '@/lib/licitacoesOpcoes';

export function UfMultiSelect({
  value,
  onChange,
}: {
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const toggleUf = (uf: string) => {
    onChange(value.includes(uf) ? value.filter((item) => item !== uf) : [...value, uf]);
  };

  const allSelected = UFS_BR.every((uf) => value.includes(uf));

  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        <label className="text-xs font-medium text-ds-text-secondary">UFs de atuação</label>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => onChange([...UFS_BR])}
            disabled={allSelected}
            className="text-xs font-medium text-ds-brand hover:underline disabled:opacity-50 disabled:no-underline"
          >
            Selecionar todas
          </button>
          <button
            type="button"
            onClick={() => onChange([])}
            disabled={value.length === 0}
            className="text-xs font-medium text-ds-text-secondary hover:underline disabled:opacity-50 disabled:no-underline"
          >
            Limpar
          </button>
        </div>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-1.5">
        {UFS_BR.map((uf) => {
          const selected = value.includes(uf);
          return (
            <button
              key={uf}
              type="button"
              onClick={() => toggleUf(uf)}
              aria-pressed={selected}
              className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
                selected
                  ? 'bg-ds-brand-subtle text-ds-brand border-ds-brand/40'
                  : 'bg-ds-surface2 text-ds-text-secondary border-ds-border hover:text-ds-text-primary'
              }`}
            >
              {uf}
            </button>
          );
        })}
      </div>
      {value.length === 0 && (
        <p className="text-xs text-ds-text-secondary italic mt-1.5">Nenhuma UF selecionada — todas as UFs são consideradas.</p>
      )}
      {allSelected && (
        <p className="text-xs text-ds-text-secondary italic mt-1.5">Todas as UFs selecionadas — cobertura nacional.</p>
      )}
    </div>
  );
}
